export function PreviewCard() {
  return (
    <section class="space-y-2" aria-label="Other account types">
      <h2 class="text-xs uppercase tracking-wider text-body/70 font-semibold">More to track</h2>
      <div class="grid grid-cols-1 gap-2">
        {[
          { label: 'RRSP', description: 'You may have RRSP room to track.' },
          { label: 'FHSA', description: 'First Home Savings Account tracking.' },
        ].map(({ label, description }) => (
          <div
            key={label}
            class="flex items-center justify-between border border-card-border rounded-lg px-4 py-3 bg-white"
          >
            <div>
              <span class="text-sm font-semibold text-hudson-navy">{label}</span>
              <p class="text-xs text-body/70 mt-0.5">{description}</p>
            </div>
            <span class="text-xs text-hudson-navy font-medium border border-grain-gold rounded px-2 py-0.5 whitespace-nowrap">
              Upgrade to track →
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}
